import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import CategoryForm from "./CategoryForm";
import CategoryTable from "./CategoryTable";
import { categoryService } from "./services/category.service";
import { toast } from "react-toastify";
import ConfirmationModal from "../../Shared/ConfirmationModal";

class ManageCategories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      submitting: false,
      formError: null,
      data: null,
      selectedRow: null,
      hasParams: false,
      error: null,
      pageNum: 0,
      pageSize: 10,
      pages: null,
      showModal: false,
      submitSucessful: false,
      filterParams: null,
      showNextJoyRide: false,
      showJoyRideOnTable: false,
    };
    this.resetButton = this.resetButton.bind(this);
  }

  componentDidMount() {
    const { pageNum, pageSize } = this.state;
    this.getAllCategories({ pageNum: pageNum + 1, pageSize });
    if (this.props.location.state) {
      const { run } = this.props.location.state;
      if (run) {
        this.setState({ showNextJoyRide: run });
      } else {
        return;
      }
    }
  }

  getAllCategories = params => {
    this.setState({ fetching: true });
    categoryService
      .getAllCategories(params)
      .then(response => {
        response &&
          this.setState({
            data: response,
            pages: Math.ceil(response.count / params.pageSize),
            error: null,
            fetching: false,
          });
      })
      .catch(error => this.setState({ error, fetching: false }));
  };

  addCategory = data => {
    const { pageSize, selectedRow } = this.state;

    this.setState({
      submitting: true,
      formError: null,
      submitSucessful: false,
    });
    categoryService
      .addCategory(data, selectedRow && selectedRow.id)
      .then(response => {
        this.setState({
          response,
          formError: null,
          submitting: false,
          submitSucessful: true,
        });
        this.getAllCategories({ pageNum: 1, pageSize });
        if (!selectedRow) {
          toast.success("Category created successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000,
          });
        } else {
          toast.success("Category updated successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000,
          });
          this.resetButton();
        }
      })

      .catch(error => this.setState({ formError: error, submitting: false }));
  };

  selectRow = selectedRow => {
    this.setState({ selectedRow: selectedRow.original, hasParams: true });
  };

  deleteCategory = item => {
    if (item.id) {
      categoryService
        .deleteCategory(item.id)
        .then(response => {
          this.setState({ response, error: null, submitting: false });
          this.fetchData();
          toast.success("Category deleted successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000,
          });
        })
        .catch(error => this.setState({ error, submitting: false }));
    }

    this.setState({
      showModal: !this.state.showModal,
    });
  };

  showConfirmation = selectedRow => {
    this.setState({
      selectedRow: selectedRow.original,
      showModal: !this.state.showModal,
    });
  };

  resetButton = () => {
    this.setState({
      hasParams: false,
      submitting: false,
      selectRow: null,
      submitSucessful: false,
    });
  };

  fetchData = () => {
    const { pageNum, pageSize, filterParams } = this.state;
    let params = { pageNum: pageNum + 1, pageSize };
    if (filterParams) {
      params = { ...filterParams, ...params };
    }
    this.getAllCategories(params);
  };

  setPageNumber = pageIndex => {
    this.setState({ pageNum: pageIndex }, () => this.fetchData());
  };

  setPageSize = (pageSize, pageIndex) => {
    this.setState({ pageSize, pageNum: pageIndex }, () => this.fetchData());
  };

  filterData = params => {
    this.setState({ filterParams: params, pageNum: 0 }, () => this.fetchData());
  };
  //=============================TOUR GUIDE SECTION=================//
  setNextJoyRide = () => {
    this.setState({ showNextJoyRide: false });
  };

  startJoyRideAtDataTable = () => {
    this.setState({ showJoyRideOnTable: true });
  };

  stopJoyRideAtDataTable = () => {
    this.setState({ showJoyRideOnTable: false });
  };
  routeChange = () => {
    this.props.history.push({
      pathname: `/interests`,
      state: { run: true },
    });
  };
    
  render() {
    const {
      fetching,
      data,
      pages,
      pageNum,
      pageSize,
      error,
      submitting,
      formError,
      hasParams,
      selectedRow,
      clearDescription,
      submitSucessful,
      showNextJoyRide,
      showJoyRideOnTable,
    } = this.state;
    return (
      <div>
        <Row>
          <Col sm="4">
            <CategoryForm
              submitting={submitting}
              error={formError}
              hasParams={hasParams}
              clearDescription={clearDescription}
              selectedRow={selectedRow}
              submitAction={this.addCategory}
              reset={this.resetButton}
              submitSucessful={submitSucessful}
              showNextJoyRide={showNextJoyRide}
              setNextJoyRide={this.setNextJoyRide}
              startJoyRideAtDataTable={this.startJoyRideAtDataTable}
            />
          </Col>
          <Col sm="8">
            <CategoryTable
              fetching={fetching}
              hasParams={hasParams}
              selectedRow={selectedRow}
              data={data}
              pages={pages}
              page={pageNum}
              pageSize={pageSize}
              selectRow={this.selectRow}
              error={error}
              filterData={this.filterData}
              DeleteModal={this.DeleteModal}
              deleteCategory={this.deleteCategory}
              showModal={this.showConfirmation}
              setPageNumber={this.setPageNumber}
              setPageSize={this.setPageSize}
              showJoyRideOnTable={showJoyRideOnTable}
              stopJoyRideAtDataTable={this.stopJoyRideAtDataTable}
              routeChange={this.routeChange}
            />
          </Col>
          <ConfirmationModal
            isOpen={this.state.showModal}
            showModal={this.showConfirmation}
            action={this.deleteCategory}
            item={selectedRow}
          />
        </Row>
      </div>
    );
  }
}

export default ManageCategories;
